import { useMemo } from "react";
import { useQuery } from "react-query";
import { getAgencySettings } from "../queries/agencySettings";
import useNetworkHeaders from "./useNetworkHeaders";

export const useClient = (site: string | undefined) => {
  const headers = useNetworkHeaders();
  const clientQuery = useQuery(["clients", site], getAgencySettings(headers), {
    enabled: !!site,
  });
  const clientId = useMemo(() => clientQuery.data?.cityId, [clientQuery?.data]);
  const name = useMemo(() => clientQuery.data?.name, [clientQuery?.data]);
  const timezone = useMemo(() => clientQuery.data?.timezoneInfo.timezone, [clientQuery?.data]);
  const wkid = useMemo(() => clientQuery.data?.wkid || 4326, [clientQuery?.data]);
  const seal = useMemo(() => clientQuery.data?.seal, [clientQuery?.data]);
  const anonymousContactId = useMemo(() => clientQuery.data?.anonymousUserId, [clientQuery?.data]);

  return {
    query: clientQuery,
    cityId: clientId,
    name,
    anonymousContactId,
    timezone,
    wkid,
    clientId,
    seal,
  };
};
